import DOMPurify from "dompurify";

// Link mở tab mới luôn kèm rel="noopener noreferrer" (chống tabnabbing).
let hooked = false;
function ensureHooks() {
  if (hooked || typeof DOMPurify.addHook !== "function") return;
  hooked = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
}

/**
 * Làm sạch HTML từ dữ liệu server/người dùng trước khi render bằng dangerouslySetInnerHTML.
 * Loại bỏ script, on* handler, javascript: URL, iframe/form...
 */
export function sanitizeHtml(html) {
  const raw = String(html ?? "");
  if (!raw) return "";
  if (typeof window === "undefined" || !DOMPurify.isSupported) {
    // Không có DOM (SSR/test cũ): trả về văn bản đã escape thay vì HTML thô.
    return raw.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  ensureHooks();
  return DOMPurify.sanitize(raw, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target"],
    FORBID_TAGS: ["style", "form", "input", "button", "textarea", "select", "iframe", "object", "embed"],
  });
}

export default sanitizeHtml;
